import {
  Avatar,
  AutoComplete,
  Button,
  Card,
  Col,
  ConfigProvider,
  DatePicker,
  Divider,
  Dropdown,
  Form,
  Input,
  Layout,
  Menu,
  message,
  Modal,
  Row,
  Select,
  Carousel,
  Table,
  Tag,
  Typography,
  Upload,
  Spin,
  Cascader,
  Checkbox,
  Radio,
  Space,
  Popconfirm,
  Tabs,
  Descriptions,
  Image,
  InputNumber,
  Transfer,
  Switch,
  List,
  Empty,
  Result,
  Breadcrumb,
  Tree,
  Steps,
  TreeSelect,
  Tooltip,
  Anchor,
  progress,
  popover,
  PageHeader,
  Pagination,
  Collapse,
  Drawer,
  Alert,
  TimePicker,
  Calendar,
} from 'ant-design-vue'

import { createApp, defineAsyncComponent } from 'vue'
import vueRoute from './router'
import 'vue3-resize/dist/vue3-resize.css'

import App from './App.vue'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate' // pinia 数据持久化
import Vue3Resize from 'vue3-resize'

import { setGlobalOptions } from 'vue-request'

import { use } from 'echarts/core'
import { CanvasRenderer } from 'echarts/renderers'
import {
  GridComponent,
  TooltipComponent,
  LegendComponent,
  DataZoomComponent
} from 'echarts/components'
import { BarChart, PieChart, LineChart, RadarChart, GaugeChart, ScatterChart } from 'echarts/charts'

import premission from '@com-common/buttonPermissions' //引入自定义指令

import './assets/icons/iconfont' // 引入 iconfont 自定义图标库
import './assets/icons/icon.css' // 引入 iconfont 自定义图标库

// 引入 iconfont 自定义组件
import ADLButtonIcon from './components/UIcomponents/ADLButtonIcon.vue'
import ADLTableTooltip from './components/UIcomponents/ADLTableTooltip.vue'
import ADLTable from './components/UIcomponents/ADLTable.vue'
import ADLIcon from './components/UIcomponents/ADLIcon.vue'
import ADLFormNum from './components/UIcomponents/ADLFormNum.vue'
import ADLFormNumMini from './components/UIcomponents/ADLFormNumMini.vue'
import ADLImport from './components/UIcomponents/ADLImport.vue'
import ADLTableSearch from './components/UIcomponents/ADLTableSearch.vue'
import ADLPageHeader from './components/UIcomponents/ADLPageHeader.vue'

import { UPLOAD_TIPS } from './Constants'

import zhCN from './locales/zh-CN/zh-CN';
import zhTW from './locales/zh-TW/zh-TW';
import enUS from './locales/en-US/en-US';
import { createI18n } from 'vue-i18n'

const i18n = createI18n({
  legacy: false,  // 启用 Composition API 模式（Vue 3 必选）
  locale: 'zh_cn', // 默认语言
  fallbackLocale: 'zh_tw', // 备用语言
  globalInjection: true,
  messages: { 'zh_cn': zhCN, 'zh_tw': zhTW, 'en_us': enUS }
});

use([
  CanvasRenderer,
  GridComponent,
  TooltipComponent,
  LegendComponent,
  DataZoomComponent,
  PieChart,
  BarChart,
  LineChart,
  RadarChart,
  GaugeChart,
  ScatterChart
])

const ECharts = defineAsyncComponent(() => import('vue-echarts'))

setGlobalOptions({
  // 当 manual 设置为 true 时，你需要手动触发 run 或者 runAsync 才会发起请求
  manual: true,
  // 通过设置延迟的毫秒数，可以延迟 loading 变成 true 的时间，有效防止闪烁。
  loadingDelay: 500,
  loadingKeep: 500,
  // 防抖需要延迟的毫秒数
  debounceInterval: 500,
  debounceOptions: {
    leading: true,
    maxWait: 500,
    trailing: false
  }
})

const app = createApp(App)

const useComponents = [
  Avatar,
  AutoComplete,
  Button,
  Card,
  Col,
  ConfigProvider,
  DatePicker,
  Divider,
  Dropdown,
  Form,
  Input,
  Layout,
  Menu,
  message,
  Modal,
  Row,
  Select,
  Carousel,
  Table,
  Tag,
  Typography,
  Upload,
  Spin,
  Cascader,
  Checkbox,
  Radio,
  Space,
  Popconfirm,
  Tabs,
  Descriptions,
  Image,
  InputNumber,
  Transfer,
  Switch,
  List,
  Empty,
  Result,
  Breadcrumb,
  Tree,
  Steps,
  TreeSelect,
  Tooltip,
  Anchor,
  progress,
  popover,
  PageHeader,
  Pagination,
  Collapse,
  Drawer,
  Alert,
  TimePicker,
  Calendar,
]

useComponents.forEach((component) => app.use(component))

app.component('ADLButtonIcon', ADLButtonIcon)
app.component('ADLTableTooltip', ADLTableTooltip)
app.component('ADLTable', ADLTable)
app.component('ADLIcon', ADLIcon)
app.component('ADLFormNum', ADLFormNum)
app.component('ADLFormNumMini', ADLFormNumMini)
app.component('ADLImport', ADLImport)
app.component('ADLTableSearch', ADLTableSearch)
app.component('ADLPageHeader', ADLPageHeader)

app.config.globalProperties.$formlayout = {
  labelCol: {
    xs: { span: 9 }, // <576px
    sm: { span: 9 }, // ≥576px
    md: { span: 9 }, // ≥768px
    lg: { span: 9 }, // ≥992px
    xl: { span: 9 }, // ≥1200px
    xxl: { span: 9 }, // ≥1600px
    xxxl: { span: 9 } // ≥2000px
  },
  wrapperCol: {
    xs: { span: 9 }, // <576px
    sm: { span: 9 }, // ≥576px
    md: { span: 9 }, // ≥768px
    lg: { span: 9 }, // ≥992px
    xl: { span: 9 }, // ≥1200px
    xxl: { span: 7 }, // ≥1600px
    xxxl: { span: 6 } // ≥2000px
  }
}

app.config.globalProperties.$modalformlayout = {
  labelCol: {
    xs: { span: 4 }, // <576px
    sm: { span: 4 }, // ≥576px
    md: { span: 4 }, // ≥768px
    lg: { span: 4 }, // ≥992px
    xl: { span: 4 }, // ≥1200px
    xxl: { span: 4 }, // ≥1600px
    xxxl: { span: 4 } // ≥2000px
  },
  wrapperCol: {
    xs: { span: 18 }, // <576px
    sm: { span: 18 }, // ≥576px
    md: { span: 18 }, // ≥768px
    lg: { span: 18 }, // ≥992px
    xl: { span: 18 }, // ≥1200px
    xxl: { span: 18 }, // ≥1600px
    xxxl: { span: 18 } // ≥2000px
  }
}

app.config.globalProperties.$uploadTips = UPLOAD_TIPS

app.directive('btn', {
  mounted: (el, bindings) => {
    premission(el, bindings)
  }
}) //全局挂载自定义指令
const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)

app.use(vueRoute).use(Vue3Resize).use(pinia).use(i18n).component('v-chart', ECharts).mount('#app')
